module.exports = __webpack_public_path__ + "h5/img/4.b0bddfdc.png";